<template>
    <b-modal
        v-model="mostrarModal"
        @show="preencherModal()"
        @hidden="resetModal()"
        size="xl"
    >
        <div slot="modal-title">{{ titulo }} - {{ requisicao.processo }}</div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-tabs>
            <b-tab title="Dados Gerais" active>
                <b-row>
                    <b-col
                        sm="12"
                        v-if="operacao == 'D' && dados && dados.tiposDevolucoes"
                    >
                        <b-form-group>
                            <label class="required">Motivo da Devolução</label>
                            <b-form-select
                                :options="dados.tiposDevolucoes"
                                v-model="tipoDevolucaoId"
                                text-field="descricao"
                                value-field="tipoDevolucaoId"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group>
                            <btn-adicionar-destinatario
                                class="mr-2"
                                @adicionarDestinatario="
                                    adicionarDestinatario($event)
                                "
                            ></btn-adicionar-destinatario>
                            <label class="required">Destinatários</label>
                            <b-form-textarea
                                v-model="encaminhamento.destinatarios"
                                :rows="3"
                                @input.native="
                                    $v.encaminhamento.destinatarios.$touch()
                                "
                                :state="
                                    $v.encaminhamento.destinatarios.$error
                                        ? false
                                        : null
                                "
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >Os destinatários são
                                obrigatórios</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group>
                            <label class="required">Título</label>
                            <b-form-input
                                v-model="encaminhamento.titulo"
                                @input.native="
                                    $v.encaminhamento.titulo.$touch()
                                "
                                :state="
                                    $v.encaminhamento.titulo.$error
                                        ? false
                                        : null
                                "
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O título é obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group
                            :state="
                                $v.encaminhamento.mensagem.$error ? false : null
                            "
                            invalid-feedback="A mensagem é obrigatória"
                        >
                            <label class="required">Mensagem</label>
                            <quill-editor
                                v-model="encaminhamento.mensagem"
                                ref="quillEditor"
                                @ready="onEditorReady($event)"
                            >
                            </quill-editor>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" v-if="operacao == 'C'">
                        <b-form-group>
                            <label class="required">Justificativa</label>
                            <b-form-textarea
                                v-model="encaminhamento.justificativa"
                                :rows="4"
                                @input.native="
                                    $v.encaminhamento.justificativa.$touch()
                                "
                                :state="
                                    $v.encaminhamento.justificativa.$error
                                        ? false
                                        : null
                                "
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >A justificativa é
                                obrigatória</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Anexos" v-if="operacao == 'E'">
                <div>
                    <b-form-file
                        v-model="arquivo"
                        :state="Boolean(arquivo)"
                        placeholder="Selecione o arquivo..."
                        browse-text="Selecionar"
                        ref="arquivoInput"
                        class="mt-2"
                    ></b-form-file>
                    <b-button
                        class="mt-3"
                        variant="primary"
                        @click.stop="inserirAnexo()"
                        v-if="arquivo"
                        ><i class="fa fa-plus"></i> Inserir Anexo</b-button
                    >
                </div>
                <app-tabela
                    :itens="encaminhamento.anexos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                    class="mt-4"
                >
                    <template slot="acoes" slot-scope="data">
                        <span class="text-danger">
                            <i
                                class="fa fa-trash fa-lg icon-button"
                                title="Excluir anexo"
                                @click.stop="excluirAnexo(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-tab>
        </b-tabs>
        <div slot="modal-footer">
            <b-button
                variant="secondary"
                @click.stop="fecharModal()"
                class="mr-2"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="desabilitaSalvar"
                @click.stop="confirmarSalvar()"
                >Enviar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import BtnAdicionarDestinatario from './BtnAdicionarDestinatario'

import Quill from 'quill'
var DirectionAttribute = Quill.import('attributors/attribute/direction')
var AlignClass = Quill.import('attributors/class/align')
var BackgroundClass = Quill.import('attributors/class/background')
var ColorClass = Quill.import('attributors/class/color')
var DirectionClass = Quill.import('attributors/class/direction')
var FontClass = Quill.import('attributors/class/font')
var SizeClass = Quill.import('attributors/class/size')
var AlignStyle = Quill.import('attributors/style/align')
var BackgroundStyle = Quill.import('attributors/style/background')
var ColorStyle = Quill.import('attributors/style/color')
var DirectionStyle = Quill.import('attributors/style/direction')
var FontStyle = Quill.import('attributors/style/font')
var SizeStyle = Quill.import('attributors/style/size')

Quill.register(DirectionAttribute, true)
Quill.register(AlignClass, true)
Quill.register(BackgroundClass, true)
Quill.register(ColorClass, true)
Quill.register(DirectionClass, true)
Quill.register(FontClass, true)
Quill.register(SizeClass, true)
Quill.register(AlignStyle, true)
Quill.register(BackgroundStyle, true)
Quill.register(ColorStyle, true)
Quill.register(DirectionStyle, true)
Quill.register(FontStyle, true)
Quill.register(SizeStyle, true)

const BlockEmbed = Quill.import('blots/block/embed')

class keepHTML extends BlockEmbed {
    static create(node) {
        return node
    }
    static value(node) {
        return node
    }
}

keepHTML.blotName = 'keepHTML'
keepHTML.className = 'keepHTML'
keepHTML.tagName = 'div'

Quill.register(keepHTML)

export default {
    props: {
        requisicao: {
            type: Object
        },

        dados: {
            type: Object
        },

        erros: {
            type: Array,
            default: () => []
        },

        titulo: {
            type: String,
            default: () => ''
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        operacao: {
            type: String,
            default: () => ''
        }
    },

    components: {
        quillEditor,
        BtnAdicionarDestinatario
    },

    data() {
        return {
            encaminhamento: {
                destinatarios: null,
                titulo: null,
                mensagem: null,
                justificativa: null,
                anexos: []
            },
            tipoDevolucaoId: 2,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'name',
                    label: 'Arquivo'
                }
            ],
            arquivo: null,
            itensPorPagina: 0
        }
    },

    methods: {
        onEditorReady(quill) {
            if (this.dados) {
                if (this.operacao == 'C' || this.operacao == 'E') {
                    quill.clipboard.dangerouslyPasteHTML(0, this.dados.mensagem)
                    // this.encaminhamento.mensagem = this.dados.mensagem
                } else if (this.operacao == 'D') {
                    this.encaminhamento.titulo = this.tipoDevolucao.titulo
                    quill.clipboard.dangerouslyPasteHTML(
                        0,
                        this.tipoDevolucao.mensagem
                    )
                }
            }
        },

        // onEditorChange({ quill, html, text }) {
        //     console.log(this.encaminhamento.mensagem)
        // },

        resetModal() {
            this.encaminhamento = {
                destinatarios: null,
                titulo: null,
                mensagem: null,
                justificativa: null,
                anexos: []
            }
            this.tipoDevolucaoId = 2
            this.$refs.quillEditor.quill.setContents([{ insert: '\n' }])
        },

        fecharModal() {
            this.resetModal()
            this.$emit('fecharModal')
        },

        preencherModal() {},

        confirmarSalvar() {
            let titulo = ''
            let mensagem = ''

            if (this.operacao == 'C') {
                titulo = 'Cancelamento da Requisição'
                mensagem = `Confirma o cancelamento da requisição referente ao processo ${this.requisicao.processo}?`
            } else if (this.operacao == 'D') {
                titulo = 'Devolução da Requisição'
                mensagem = `Confirma a devolução da requisição referente ao processo ${this.requisicao.processo}?`
            } else if (this.operacao == 'E') {
                titulo = 'Envio da Requisição'
                mensagem = `Confirma o envio da requisição referente ao processo ${this.requisicao.processo}?`
            }
            this.$swal({
                title: titulo,
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let encaminhamentoDto = {
                destinatarios: this.encaminhamento.destinatarios,
                titulo: this.encaminhamento.titulo,
                mensagem: this.encaminhamento.mensagem
            }
            if (this.operacao == 'E') {
                encaminhamentoDto.anexos = this.encaminhamento.anexos
            }
            if (this.operacao == 'C') {
                encaminhamentoDto.justificativa =
                    this.encaminhamento.justificativa
            }
            if (this.operacao == 'D') {
                encaminhamentoDto.tipoDevolucao = this.tipoDevolucaoId
            }
            this.$emit('salvar', encaminhamentoDto)
        },

        inserirAnexo() {
            this.encaminhamento.anexos.push(this.arquivo)
            this.arquivo = null
        },

        excluirAnexo(anexo) {
            for (
                let index = 0;
                index < this.encaminhamento.anexos.length;
                index++
            ) {
                const anexoAtual = this.encaminhamento.anexos[index]
                if (anexoAtual.name == anexo.name) {
                    this.encaminhamento.anexos.splice(index, 1)
                    break
                }
            }
        },

        adicionarDestinatario(email) {
            if (this.encaminhamento.destinatarios) {
                if (!this.encaminhamento.destinatarios.includes(email)) {
                    this.encaminhamento.destinatarios += `, ${email}`
                }
            } else {
                this.encaminhamento.destinatarios = email
            }
        }
    },

    computed: {
        desabilitaSalvar() {
            return this.$v.$invalid
        },

        tipoDevolucao() {
            if (this.dados && this.dados.tiposDevolucoes) {
                return this.dados.tiposDevolucoes.find(
                    (p) => p.tipoDevolucaoId == this.tipoDevolucaoId
                )
            }
        }
    },

    created() {},

    validations: {
        encaminhamento: {
            destinatarios: { required },
            titulo: { required },
            mensagem: { required },
            justificativa: {
                justificativaOk() {
                    if (this.operacao == 'C') {
                        return (
                            this.encaminhamento.justificativa != null &&
                            this.encaminhamento.justificativa != undefined &&
                            this.encaminhamento.justificativa != ''
                        )
                    }
                    return true
                }
            }
        }
    },

    watch: {
        dados() {
            this.encaminhamento.destinatarios = this.dados.destinatarios
            if (this.operacao == 'C' || this.operacao == 'E') {
                this.encaminhamento.titulo = this.dados.titulo
            }
        },

        tipoDevolucaoId() {
            this.encaminhamento.titulo = this.tipoDevolucao.titulo
            if (this.$refs.quillEditor) {
                this.$refs.quillEditor.quill.setContents([{ insert: '\n' }])
                this.$refs.quillEditor.quill.clipboard.dangerouslyPasteHTML(
                    0,
                    this.tipoDevolucao.mensagem
                )
            }
        }
    }
}
</script>
